import { CalendarDays, Clock3 } from "lucide-react";
import { useState, type ChangeEvent, type InputHTMLAttributes } from "react";

type TemporalInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

function dateLabel(value: string) {
  const [year, month, day] = value.split("-");
  return year && month && day ? `${day}/${month}/${year}` : "Choisir une date";
}

function TemporalInput({ kind, value, defaultValue, onChange, ...props }: TemporalInputProps & { kind: "date" | "time" }) {
  const [internalValue, setInternalValue] = useState(String(defaultValue ?? ""));
  const selectedValue = String(value ?? internalValue);
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (value === undefined) setInternalValue(event.target.value);
    onChange?.(event);
  };

  return (
    <span className="temporal-input">
      <span className="temporal-input-value" aria-hidden="true">{kind === "date" ? dateLabel(selectedValue) : selectedValue || "Choisir une heure"}</span>
      {kind === "date" ? <CalendarDays aria-hidden="true" /> : <Clock3 aria-hidden="true" />}
      <input {...props} className="temporal-input-native" type={kind} value={value} defaultValue={value === undefined ? defaultValue : undefined} onChange={handleChange} />
    </span>
  );
}

export function DateInput(props: TemporalInputProps) {
  return <TemporalInput {...props} kind="date" />;
}

export function TimeInput(props: TemporalInputProps) {
  return <TemporalInput {...props} kind="time" />;
}
